import { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router';

type ProtectedRouteProps = {
  redirectPath?: string;
  children?: ReactNode;
  isAllowed: boolean;
};

function ProtectedRoute({
  isAllowed,
  redirectPath = '/',
  children
}: ProtectedRouteProps) {
  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
}

export default ProtectedRoute;
